export default __webpack_public_path__ + "static/media/Belt of the Fallen Empire (nm).c9366170.jpg";